// @flow

import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import ReduxBlockUi from 'react-block-ui/redux';
import 'react-block-ui/style.css';
import { FormattedMessage } from 'react-intl';

//Lodash
import _forEach from 'lodash/forEach';
import _head from 'lodash/head';
import _has from 'lodash/has';
import _split from 'lodash/split';


//High Order Objects
import {connect} from 'react-redux';
import withWidth from 'material-ui/utils/withWidth';
import {withRouter} from 'react-router'
import muiThemeable from 'material-ui/styles/muiThemeable';

//Actions
import {
    APP_LOAD,
    REDIRECT,
    CART_ADD,
    CART_ADD_ERROR,
    CART_CLEAN,
    PERSONAL_SET_COUNTRY,
    PERSONAL_SET_COUNTRY_ERROR,
    PERSONAL_SET_CURRENCY,
    PERSONAL_UPDATE_INFO,
    CARD_UPDATE_INFO,
    CART_SHOULD_UPDATE_TOTALS,
    CART_CHECK_TYPE,
    UPDATE_STEP,
    CHANGE_STEP,
    CART_CAN_SUBMIT,
    CART_PAY,
    CART_PAID,
    CARD_ADD_ERROR,
    CART_PAY_ERROR,
    ALERT_OPEN,
    ALERT_CLOSE
} from '../../actions/actionTypes';

//Error strings
import {
    API_VARIANTS_NOT_FOUND,
    API_VARIANTS_UNDEFINED,
    API_VARIANTS_NO_STOCK
} from '../../lang/alerts';

//Services
import GetProduct from '../../services/getProduct';
import Currencies from '../../services/currencies';


//Containers
import PreviewSidebar from '../presentational/infoSidebar';
import Products from '../containers/products';
import Coupon from '../containers/coupons';
import Totals from '../presentational/totals';
import Shipping from './shipping';
import Billing from './billing';
import Payment from '../../Modules/payment/components/Payment';
import {AuthLayout} from '../../Modules/auth';

//Presentational components
import {
    Step,
    Stepper,
    StepLabel,
    StepContent,
    StepButton
} from 'material-ui/Stepper';
import RaisedButton from 'material-ui/RaisedButton';
import Alert from '../presentational/elements/alert';
import ArrowForwardIcon from 'material-ui/svg-icons/navigation/arrow-forward';
import { format } from 'util';

const mapStateToProps = state => (state);

const mapDispatchToProps = dispatch => ({
    onLoad: (payload, token) =>
        dispatch({type: APP_LOAD, payload, token, skipTracking: true}),
    onRedirect: () =>
        dispatch({type: REDIRECT}),
    onSetCountry: payload =>
        dispatch({type: PERSONAL_SET_COUNTRY, payload}),
    logCountryError: () =>
        dispatch({type: PERSONAL_SET_COUNTRY_ERROR}),
    logProductError: (product) =>
        dispatch({type: CART_ADD_ERROR, product: product}),
    onSetCurrency: payload =>
        dispatch({type: PERSONAL_SET_CURRENCY, payload}),
    onUpdatePersonalInfo: (key, value) =>
        dispatch({type: PERSONAL_UPDATE_INFO, key, value}),
    onUpdateCardInfo: (key, value) =>
        dispatch({type: CARD_UPDATE_INFO, key, value}),
    onCartAdd: data =>
        dispatch({type: CART_ADD, id: data.id, payload: data}),
    onCartSetTotals: () =>
        dispatch({type: CART_SHOULD_UPDATE_TOTALS}),
    onUpdateStep: (key, value) =>
        dispatch({type: UPDATE_STEP, key, value}),
    onChangeStep: payload =>
        dispatch({type: CHANGE_STEP, payload}),
    onOpenAlert: (value) =>
        dispatch({type: ALERT_OPEN, message: value}),
    onCloseAlert: () =>
        dispatch({type: ALERT_CLOSE}),
    onCartCanSubmit: () =>
        dispatch({type: CART_CAN_SUBMIT}),
    onCheckCartType: () =>
        dispatch({type: CART_CHECK_TYPE}),
    onClearCart: () =>
        dispatch({type: CART_CLEAN}),
});

class CartManager extends Component <any, any> {

    componentWillReceiveProps() {
        if (this.props.card.token && this.props.common.canSubmit === false) {
            this.props.onCartCanSubmit();
        }
    }

    componentWillMount() {
        //Set country and currency
        Currencies.getClientCountry()
            .then(data => {
                const countryCurrency = Currencies.getCurrencyByCountry(data.country);
                this.props.onSetCountry(countryCurrency.alpha2Code);
                const currency = _head(countryCurrency.currencies);
                this.props.onSetCurrency(currency.code)
            })
            .catch(error => {
                this.props.logCountryError();
                this.props.onSetCountry('GB');
                this.props.onSetCurrency('GBP');
            });

        if (this.props.match.params.hasOwnProperty("id")) {
            GetProduct.requestProduct(this.props.match.params.id, 1).then(data => {
                this.props.onCartAdd(data);
                this.props.onCartSetTotals();
            }).catch(error => {
                this.handleProductErrors(error);
            });
        }

        if (this.props.match.params.hasOwnProperty("bundleId")) {
            GetProduct.requestBundle(this.props.match.params.bundleId, 1, this.props.match.params.variantIds).then(data => {
                this.props.onCartAdd(data);
                this.props.onCartSetTotals();
            }).catch(error => {
                this.handleProductErrors(error);
            });
        }

        if (this.props.match.params.hasOwnProperty("cartIds")) {
            //this.props.onClearCart();
            const ids = _split(decodeURIComponent(this.props.match.params.cartIds), '|');
            _forEach(ids, (value) => {
                const params = _split(value, ':');
                const qty = (params.length === 2) ? params[1] : 1;
                const components = _split(params[0], '=');
                switch (components.length) {
                    case 1:
                        const variant = components[0];
                        GetProduct.requestProduct(variant, qty).then(data => {
                            this.props.onCartAdd(data);
                            this.props.onCartSetTotals();
                        }).catch(error => {
                            this.handleProductErrors(error);
                        });
                        break;
                    case 2:
                        const variants = components[1];
                        const bundleId = components[0];
                        GetProduct.requestBundle(bundleId, qty, variants).then(data => {
                            this.props.onCartAdd(data);
                            this.props.onCartSetTotals();
                        }).catch(error => {
                            this.handleProductErrors(error);
                        });
                        break;
                    default:
                        return;
                }
            });
        }

        this.props.onCheckCartType();
    }

    getStyles = () => {
        return this.props.muiTheme;
    };

    handleStep = (key, value) => {
        this.props.onUpdateStep(key, value);
    };

    handleNextStep = () => {
        if (this.props.common.stepIndex < 2) {
            const newStep = this.props.common.stepIndex + 1;
            this.props.onChangeStep(newStep);
        }
    };

    handlePrevStep = () => {
        if (this.props.common.stepIndex > 1) {
            const newStep = this.props.common.stepIndex - 1;
            this.props.onChangeStep(newStep);
        }
    };

    handleChangeStep = (step) => {
        this.props.onChangeStep(step);
    };

    handleCloseAlert = () => {
        this.props.onCloseAlert();
    };

    handleProductErrors = (error) => {
        if (_has(error, 'response.data.data.error')) {
            let message;
            switch (error.response.data.data.error) {
                case 'ProductNotFound':
                    message = API_VARIANTS_NOT_FOUND;
                    break;
                case 'NoStockProduct':
                    message = API_VARIANTS_NO_STOCK;
                    break;
                default:
                    message = error.response.data.data.message;
            }
            this.props.onOpenAlert(message);
            this.props.logProductError(error.response)
        } else if (error.request) {
            this.props.onOpenAlert(API_VARIANTS_UNDEFINED);
            this.props.logProductError("Undefined error adding a product")
        } else {
            // Something happened in setting up the request that triggered an Error
            this.props.onOpenAlert(API_VARIANTS_UNDEFINED);
            this.props.logProductError("Undefined error adding a product")
        }

    };

    isDisabled(step) {
        const {isDigital, stepReady, needs_billing} = this.props.common;
        switch (step) {
            case 1: //Shipping
                return !stepReady.personal;
            case 2: //Payment
                return !(
                    stepReady.personal &&
                    (
                        (!isDigital && stepReady.shippingAddress && stepReady.shippingOptions) ||
                        (isDigital && stepReady.billingAddress)
                    ) &&
                    (
                        !needs_billing || (needs_billing && stepReady.billingAddress)
                    )
                );
            default:
                return true;
        }
    }

    getStepContent(stepIndex) {
        const {stepReady} = this.props.common;
        switch (stepIndex) {
            case 0:
                return <div>
                    <AuthLayout/>
                    {stepReady.personal &&
                    <RaisedButton
                        label={
                            <FormattedMessage
                                id="checkout.next"
                                defaultMessage="Next"
                            />
                        }
                        primary={true}
                        onClick={this.handleNextStep}
                        className="nextBtn spacing"
                    />
                    }
                </div>;
            case 1:
                return <div>
                    {!this.props.common.isDigital && <Shipping/>}
                    <Billing/>
                    <RaisedButton
                        label={
                            <FormattedMessage
                                id="checkout.next"
                                defaultMessage="Next"
                            />
                        }
                        primary={true}
                        disabled={this.isDisabled(2)}
                        onClick={this.handleNextStep}
                        className="nextBtn spacing"
                    />
                </div>;
            case 2:
                return <div>
                    <div className="clear">
                        <br/>
                        <p className="subtitle">
                            <FormattedMessage
                                id="checkout.reviewYourOrder"
                                defaultMessage="Review your order & Make Payment"
                            />
                        </p>
                        <Totals {...this.props.cart.totals} currency={this.props.personal.currency_code}/>
                    </div>
                    <Payment/>
                    <div className="termsLine">
                        <small className="termsText">
                        <FormattedMessage
                            id="checkout.termsAndServices"
                            defaultMessage="By purchasing you agree to our"
                        />
                         <a
                            href="https://aflete.com/terms-conditions/" target="_blank"
                            rel="noopener noreferrer"> 
                                <FormattedMessage
                                    id="checkout.termsLink"
                                    defaultMessage=" terms and conditions."
                                />
                        </a></small>
                    </div>
                </div>;
            default:
                return false;
        }
    };

    getStepper() {
        const {stepIndex, visited, stepReady} = this.props.common;
        const styles = this.getStyles();
        return <Stepper linear={false} orientation="horizontal" style={styles.stepper}
                     className="stepperr" connector={<ArrowForwardIcon/>}>
                <Step completed={stepReady.personal === true} active={stepIndex === 0}>
                    <StepButton onClick={() => this.handleChangeStep(0)}>
                        <FormattedMessage 
                            id="checkout.signupOrLogin"
                            defaultMessage="Signup or Login"
                        />                        
                    </StepButton>
                </Step>
                <Step completed={!this.isDisabled(2)} active={stepIndex === 1}>
                    <StepButton onClick={() => this.handleChangeStep(1)} disabled={this.isDisabled(1)}>
                        <FormattedMessage
                            id="checkout.billingAddress"
                            defaultMessage={this.props.common.isDigital ? 'Billing address' : 'Address and Shipping'}
                        />
                    </StepButton>
                </Step>
                <Step completed={visited.indexOf(2) !== -1} active={stepIndex === 2}>
                    <StepButton onClick={() => this.handleChangeStep(2)} disabled={this.isDisabled(2)}>
                        <FormattedMessage
                            id="checkout.reviewYourOrder"
                            defaultMessage="Review your order & Make Payment"
                        />
                    </StepButton>
                </Step>
            </Stepper>
            ;
    }

    getMobileStepper() {
        const {stepIndex, visited, stepReady} = this.props.common;
        return <Stepper orientation="vertical" connector={null}>
                <Step completed={stepReady.personal === true} active={stepIndex === 0}>
                    <StepButton onClick={() => this.handleChangeStep(0)}>
                        <StepLabel className="step_label">
                            <FormattedMessage 
                                id="checkout.signupOrLogin"
                                defaultMessage="Signup or Login"
                            />
                        </StepLabel>
                    </StepButton>
                    <StepContent className="step_content">
                        {this.getStepContent(0)}
                    </StepContent>
                </Step>
                <Step completed={!this.isDisabled(2)} active={stepIndex === 1}>
                    <StepButton onClick={() => this.handleChangeStep(1)} disabled={this.isDisabled(1)}>
                        <StepLabel className="step_label">
                            <FormattedMessage
                                id="checkout.billingAddress"
                                defaultMessage={this.props.common.isDigital ? 'Billing address' : 'Address and Shipping'}
                            />
                        </StepLabel>
                    </StepButton>
                    <StepContent className="step_content">
                        {this.getStepContent(1)}
                    </StepContent>
                </Step>
                <Step completed={visited.indexOf(2) !== -1} active={stepIndex === 2}>
                    <StepButton onClick={() => this.handleChangeStep(2)} disabled={this.isDisabled(2)}>
                        <StepLabel className="step_label">
                            <FormattedMessage
                                id="checkout.reviewYourOrder"
                                defaultMessage="Review your order & Make Payment"
                            />
                        </StepLabel>
                    </StepButton>
                    <StepContent className="step_content">
                        {this.getStepContent(2)}
                    </StepContent>
                </Step>
            </Stepper>
    }

    render() {
        const {stepIndex} = this.props.common;
        const styles = this.getStyles();

        if (this.props.common.submitted) {
            return (
                <Redirect push to={{
                    pathname: '/thank-you',
                    state: this.props.personal.first_name
                }}/>
            )
        }

        switch (this.props.width) {
            case 1: //Small
            case 2: //Medium
                return (
                    <div className="wrapper">
                        <div className="topBanner"><h1>Checkout</h1><img
                            src="https://s3.eu-west-2.amazonaws.com/assets.aflete.com/checkout/powered.png" alt=""/></div>
                        <div className="mobile-container">
                            <h3 className="thin-h3">Order Summary</h3>
                            <p className="mobile-subtitle">Excited for you to join everyone <span role="img"
                                                                                                  aria-label="happy">🙂</span>
                            </p>
                            <hr/>
                            <Products/>
                            <Coupon/>
                            <Totals {...this.props.cart.totals} currency={this.props.personal.currency_code}/>
                            <hr/>
                            <p className="mobile-heading">Complete Your Order</p>

                            <div className="mainMobile">
                                <ReduxBlockUi tag="div"
                                              block={CART_PAY}
                                              unblock={[CART_PAID, CARD_ADD_ERROR, CART_PAY_ERROR, /fail/i]}
                                              message="Your order is being processed, please do not refresh (It may take some time)"
                                >
                                    {this.getMobileStepper()}
                                </ReduxBlockUi>
                                <Alert content={this.props.common.alertMessage} handleClose={this.handleCloseAlert}
                                       openForm={this.props.common.alertOpen}/>
                            </div>
                        </div>
                    </div>
                );
            case 3: //Large
                return (
                    <div className="wrapper">
                        <div className="topBanner"><h1>Checkout</h1><img
                            src="https://s3.eu-west-2.amazonaws.com/assets.aflete.com/checkout/powered.png" alt=""/></div>
                        <div className="mainDesktop">
                            <ReduxBlockUi tag="div"
                                          block={CART_PAY}
                                          unblock={[CART_PAID, CARD_ADD_ERROR, CART_PAY_ERROR, /fail/i]}
                                          message="Your order is being processed, please do not refresh (It may take some time)"
                            >
                                <div className="mainDesktop__container">
                                    {this.getStepper()}
                                    <div style={styles.content}>
                                        <div>{this.getStepContent(stepIndex)}</div>
                                    </div>
                                </div>
                            </ReduxBlockUi>
                            <Alert content={this.props.common.alertMessage} handleClose={this.handleCloseAlert}
                                   openForm={this.props.common.alertOpen}/>
                        </div>
                        <PreviewSidebar style={styles.preview}
                                        {...this.props.cart}
                                        currency={this.props.personal.currency_code}/>
                    </div>
                );
            default:
                throw new Error(`Unknown width`);
        }
    }
}

export default withRouter(muiThemeable()(connect(mapStateToProps, mapDispatchToProps)(withWidth()(CartManager))));
